var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-div',[_c('div',{staticClass:"contArea"},[_c('div',{staticClass:"midBox"},[_c('div',{staticClass:"confirmBox"},[_c('strong',{staticClass:"tit"},[_vm._v(" 현재 BMW ServiceCare+ 은"),_c('br'),_vm._v(" BMW Plus App에서만 사용 가능합니다. ")]),_c('button-app-download')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }